import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-138fce2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "indicator-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" }, null, -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "modal-title space-between" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "wrapper" }
const _hoisted_9 = { class: "modal_content_container" }
const _hoisted_10 = {
  key: 0,
  class: "select_text"
}
const _hoisted_11 = {
  key: 1,
  class: "select_text"
}
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "bank_wrap"
}
const _hoisted_15 = { class: "bank_logo" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = ["id"]
const _hoisted_19 = {
  key: 1,
  class: "bank_wrap"
}
const _hoisted_20 = { class: "bank_logo" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_23 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.type === 'refund')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "은행 계좌 입력"))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "증권 계좌 입력")),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'취소'}); _ctx.dismiss()})
            }, "취소")
          ])
        ])
      ])
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.type === 'refund')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 은행선택 "))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, " 증권사선택 ")),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankList, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "bank_box",
                  onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':`${_ctx.type === 'refund'?'은행선택':'증권사선택'}`, 'clickContent': `${_ctx.type === 'refund'?v.bankName:v.stockBankName}`}); _ctx.selectBank(v)}
                }, [
                  (_ctx.type === 'refund')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("img", {
                            src: v.bankLogoUrl,
                            class: "img-circle img-responsive"
                          }, null, 8, _hoisted_16),
                          _hoisted_17
                        ]),
                        _createElementVNode("span", {
                          id: v.bankId,
                          class: "bank_name"
                        }, _toDisplayString(v.bankName), 9, _hoisted_18)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("img", {
                            src: v.stockBankLogoUrl,
                            class: "img-circle img-responsive"
                          }, null, 8, _hoisted_21),
                          _hoisted_22
                        ]),
                        _createElementVNode("span", {
                          id: v.stockBankId,
                          class: "bank_name"
                        }, _toDisplayString(v.stockBankName), 9, _hoisted_23)
                      ]))
                ], 8, _hoisted_13))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}